import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";
import {
  AWS_URL,
  REDUX_LOCAL_STORE_KEY,
} from "../../../components/config/constants";
import Loader from "../../../components/Loader";
import { isNotValid } from "../../../components/helper/GeneralHelper";
import PostService from "../../../services/PostService";
import GeneralService from "../../../services/GeneralService";
import StoryService from "../../../services/StoryService";
import controlMediaSize from "../../../components/helper/ControlMedia";

const UploadStories = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const clickInput = useRef(null);
  
  const [state, setState] = useState({
    showFilters: false,
    file: null,
    description: "",
    urlForUpload: "",
    uploadedMedia: "",
    uploadedMediaDataUrl: "",
    userId: JSON.parse(localStorage.getItem(REDUX_LOCAL_STORE_KEY))
      .authentication.userData._id,
    fileName: "",
    fileType: "",
    thumbNailImage: "",
    blurredThumbNailImage: "",
    inputFileStory: null,
    inputFileEvent: null,
    loading: false,
  });

  const updateState = (newState) => {
    setState(prevState => ({ ...prevState, ...newState }));
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const isImage = (file) => {
    if (!file || !file.type) return false;
    return file.type.includes("image");
  };

  const isVideo = (file) => {
    if (!file || !file.type) return false;
    return file.type.includes("video");
  };

  const getVideoDuration = (file) => {
    return new Promise((resolve, reject) => {
      if (isImage(file)) {
        resolve("isPhoto");
        return;
      }
      
      try {
        const videoElement = document.createElement("video");
        videoElement.onloadedmetadata = () => {
          const duration = videoElement.duration;
          videoElement.remove();
          resolve(duration);
        };

        videoElement.onerror = () => {
          videoElement.remove();
          reject("error");
        };
        
        videoElement.src = URL.createObjectURL(file);
      } catch (error) {
        console.error("Error getting video duration:", error);
        reject(error);
      }
    });
  };

  const putFileThumbnail = (url, file, name, uploadedMedia) => {
    updateState({ loading: true });
    
    PostService.putFile(url, file)
      .then(() => {
        updateState({ thumbNailImage: name });
        
        try {
          const reader = new FileReader();
          reader.onload = (event) => {
            const dataURL = event.target.result;
            const img = new Image();
            img.src = dataURL;

            img.onload = () => {
              const canvas = document.createElement("canvas");
              canvas.width = img.width;
              canvas.height = img.height;

              const ctx = canvas.getContext("2d");
              ctx.filter = "blur(20px)";
              ctx.drawImage(img, 0, 0, img.width, img.height);
              
              canvas.toBlob(async (blob) => {
                const imageFile = new File([blob], "thumbnailBlur.jpg", {
                  type: "image/jpeg",
                });
                
                const formData = new FormData();
                formData.append("file", imageFile);
                formData.append("_id", state.userId);

                const params2 = {
                  folder: "thumbnailBlur",
                  filename: `blurredThumbnail${new Date().getTime("L")}${imageFile.name}`,
                };

                GeneralService.obtainUrlUpload({ ...params2 })
                  .then((res) => {
                    PostService.putFile(res.data.data, imageFile)
                      .then(() => {
                        updateState({ blurredThumbNailImage: params2.filename });
                        createStorie({
                          uploadedMedia,
                          fileType: "video",
                          thumbNailImage: name,
                          blurredThumbNailImage: params2.filename,
                        });
                      })
                      .catch((err) => {
                        console.error("Error uploading blurred thumbnail:", err);
                        updateState({ loading: false });
                      });
                  })
                  .catch((err) => {
                    console.error("Error obtaining upload URL:", err);
                    updateState({ loading: false });
                  });
              }, "image/jpeg");
            };
          };

          reader.readAsDataURL(file);
        } catch (error) {
          console.error("Error processing thumbnail:", error);
          updateState({ loading: false });
        }
      })
      .catch((err) => {
        console.error("Error uploading thumbnail:", err);
        updateState({ loading: false });
      });
  };

  const submitThumbnail = async (file) => {
    if (!file) {
      toast.error(t("clip.invalidFile"));
      updateState({ loading: false });
      return;
    }
    
    updateState({ loading: true });
    
    const formData = new FormData();
    formData.append("file", file);
    formData.append("_id", state.userId);

    try {
      const reader = new FileReader();
      reader.onload = (event) => {
        const dataURL = event.target.result;
        updateState({ uploadedMediaDataUrl: dataURL });
      };
      reader.readAsDataURL(file);

      const fileName = `${new Date().getTime("L")}${file.name}`;
      updateState({ fileName });
      
      const params = {
        folder: "media",
        filename: fileName,
      };

      GeneralService.obtainUrlUpload({ ...params })
        .then((res) => {
          updateState({ urlForUpload: res.data.data, file: formData });
          
          PostService.putFile(res.data.data, file)
            .then(() => {
              updateState({ uploadedMedia: params.filename });
              
              try {
                const url = URL.createObjectURL(file);
                const videoElement = document.createElement("video");
                videoElement.src = url;

                videoElement.addEventListener("canplaythrough", function onCanPlayThrough() {
                  videoElement.removeEventListener("canplaythrough", onCanPlayThrough);
                  videoElement.currentTime = 0;

                  const canvas = document.createElement("canvas");
                  canvas.width = videoElement.videoWidth;
                  canvas.height = videoElement.videoHeight;

                  const context = canvas.getContext("2d");

                  videoElement.addEventListener("seeked", function onSeeked() {
                    videoElement.removeEventListener("seeked", onSeeked);

                    context.drawImage(
                      videoElement,
                      0,
                      0,
                      canvas.width,
                      canvas.height
                    );

                    canvas.toBlob((blob) => {
                      const imageFile = new File([blob], "thumbnail.jpg", {
                        type: "image/jpeg",
                      });
                      
                      const formData = new FormData();
                      formData.append("file", imageFile);
                      formData.append("_id", state.userId);

                      const params = {
                        folder: "thumbnail",
                        filename: `${new Date().getTime("L")}${imageFile.name}`,
                      };

                      GeneralService.obtainUrlUpload({ ...params })
                        .then((res) => {
                          putFileThumbnail(
                            res.data.data,
                            imageFile,
                            params.filename,
                            fileName
                          );
                        })
                        .catch((err) => {
                          console.error("Error obtaining upload URL:", err);
                          updateState({ loading: false });
                        });
                    }, "image/jpeg");
                  });
                  
                  videoElement.currentTime = 0;
                });
              } catch (error) {
                console.error("Error processing video:", error);
                updateState({ loading: false });
              }
            })
            .catch((err) => {
              console.error("Error uploading file:", err);
              updateState({ loading: false });
            });
        })
        .catch((err) => {
          console.error("Error obtaining URL:", err);
          updateState({ loading: false });
        });
    } catch (error) {
      console.error("Error reading file:", error);
      updateState({ loading: false });
    }
  };

  const putFile = (url, file, fileName) => {
    if (!file) {
      updateState({ loading: false });
      return;
    }

    const upMedia = fileName;
    
    PostService.putFile(url, file)
      .then(() => {
        const fileType = isImage(file) ? "image" : isVideo(file) ? "video" : "undefined";
        updateState({ fileType, uploadedMedia: upMedia });
        
        if (fileType === "image") {
          try {
            const img = new Image();
            img.src = state.uploadedMediaDataUrl;

            img.onload = () => {
              const canvas = document.createElement("canvas");
              canvas.width = img.width;
              canvas.height = img.height;

              const ctx = canvas.getContext("2d");
              ctx.filter = "blur(20px)";
              ctx.drawImage(img, 0, 0, img.width, img.height);

              canvas.toBlob((blob) => {
                const imageFile = new File([blob], "thumbnailBlur.jpg", {
                  type: "image/jpeg",
                });
                
                const formData = new FormData();
                formData.append("file", imageFile);
                formData.append("_id", state.userId);

                const params2 = {
                  folder: "thumbnailBlur",
                  filename: `blurredThumbnail${new Date().getTime("L")}${imageFile.name}`,
                };
                
                GeneralService.obtainUrlUpload({ ...params2 })
                  .then((res) => {
                    PostService.putFile(res.data.data, imageFile)
                      .then(() => {
                        updateState({ blurredThumbNailImage: params2.filename });
                        createStorie({
                          uploadedMedia: upMedia,
                          fileType: "image",
                          thumbNailImage: upMedia,
                          blurredThumbNailImage: params2.filename,
                        });
                      })
                      .catch((err) => {
                        console.error("Error uploading blurred file:", err);
                        updateState({ loading: false });
                      });
                  })
                  .catch((err) => {
                    console.error("Error obtaining upload URL:", err);
                    updateState({ loading: false });
                  });
              }, "image/jpeg");
            };

            img.onerror = () => {
              console.error("Error loading image");
              updateState({ loading: false });
            };
          } catch (error) {
            console.error("Error processing image:", error);
            updateState({ loading: false });
          }
        } else if (fileType === "video") {
          // Will be handled by submitThumbnail for videos
          createStorie({
            uploadedMedia: upMedia,
            fileType: "video",
            thumbNailImage: "",
            blurredThumbNailImage: "",
          });
        } else {
          updateState({ loading: false });
          toast.error(t("clip.invalidFile"));
        }
      })
      .catch((err) => {
        console.error("Error uploading file:", err);
        updateState({ loading: false });
      });
  };

  const createStorie = ({ uploadedMedia, fileType, thumbNailImage, blurredThumbNailImage }) => {
    
    if (uploadedMedia) {
      if (fileType !== "undefined") {
        const params = {
          storyMedia: {
            isVaultMedia: false,
            name: uploadedMedia,
            thumbNailImage:
              fileType === "video"
                ? thumbNailImage
                : uploadedMedia,
            type: fileType,
            blurredThumbNailImage: blurredThumbNailImage,
          },
        };
        
        StoryService.createStorie({ ...params })
          .then(() => {
            updateState({ loading: false });
            toast.success(t("stories.storySuccessfullyCreated"));
            history.push("/");
          })
          .catch((err) => {
            updateState({ loading: false });
            toast.error(err.message || t("stories.creationError"));
          });
      } else {
        updateState({ loading: false });
        toast.error(t("clip.invalidFile"));
      }
    } else {
      updateState({ loading: false });
      toast.error(t("stories.selectVideoOrPhoto"));
    }
  };

  const submitStories = async (file, event) => {
    if (isNotValid(event) || !file) {
      updateState({ fileType: "undefined" });
      toast.error(t("clip.invalidFile"));
      return;
    }
    
    updateState({ loading: true });
    event.preventDefault();
    
    try {
      if (isImage(file) || isVideo(file)) {
        const duration = await getVideoDuration(file);
        
        // Check if video is within 60 seconds or is an image
        if ((isVideo(file) && (duration === "isPhoto" ? 0 : duration) <= 60) || isImage(file)) {
          if (file.type.includes("video")) {
            submitThumbnail(file);
          } else {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("_id", state.userId);

            const reader = new FileReader();
            reader.onload = (event) => {
              const dataURL = event.target.result;
              updateState({ uploadedMediaDataUrl: dataURL });
            };
            reader.readAsDataURL(file);

            const fileName = `${new Date().getTime("L")}${file.name}`;
            updateState({ fileName });
            
            const params = {
              folder: "media",
              filename: fileName,
            };

            GeneralService.obtainUrlUpload({ ...params })
              .then((res) => {
                updateState({ urlForUpload: res.data.data, file: formData });
                putFile(res.data.data, file, fileName);
              })
              .catch((err) => {
                console.error("Error obtaining upload URL:", err);
                updateState({ loading: false });
              });
          }
        } else {
          updateState({ loading: false });
          toast.error(t("clip.maxOneMinute"));
        }
      } else {
        updateState({ fileType: "undefined", loading: false });
        toast.error(t("clip.invalidFile"));
      }
    } catch (error) {
      console.error("Error submitting story:", error);
      updateState({ loading: false });
      toast.error(t("stories.uploadError"));
    }
  };

  const handleFileChange = async (event) => {
    if (!event.target.files || !event.target.files[0]) {
      return;
    }
    
    try {
      const controlledFile = await controlMediaSize(
        [{ file: event.target.files[0] }],
        t
      );
      
      if (controlledFile) {
        const file = event.target.files[0];
        
        updateState({
          inputFileStory: file,
          inputFileEvent: event,
          fileType: file.type.includes("image") 
            ? "image" 
            : file.type.includes("video") ? "video" : "undefined"
        });

        const reader = new FileReader();
        reader.onload = (event) => {
          updateState({ uploadedMediaDataUrl: event.target.result });
        };
        reader.readAsDataURL(file);
      }
    } catch (error) {
      console.error("Error handling file change:", error);
    }
  };

  const handleFileDrop = (event) => {
    event.preventDefault();
    
    if (!event.dataTransfer.files || !event.dataTransfer.files[0]) {
      return;
    }
    
    const file = event.dataTransfer.files[0];
    
    updateState({
      inputFileStory: file,
      inputFileEvent: event,
      fileType: file.type.includes("image") 
        ? "image" 
        : file.type.includes("video") ? "video" : "undefined"
    });

    try {
      const reader = new FileReader();
      reader.onload = (e) => {
        updateState({ uploadedMediaDataUrl: e.target.result });
      };
      reader.readAsDataURL(file);
    } catch (error) {
      console.error("Error handling file drop:", error);
    }
  };

  const { loading, uploadedMediaDataUrl, fileType, uploadedMedia, inputFileStory, inputFileEvent } = state;
  const width = window.innerWidth;
  const isMobile = width <= 512;
  const isTab = width <= 992;

  return (
    <>
      <div className={`${loading ? "main-overlay" : ""}`}></div>
      {loading && <Loader />}
      
      <div
        style={
          isMobile
            ? {
                padding: "20px",
                height: "calc(100dvh - 64px)",
                overflow: "hidden",
              }
            : {}
        }
        className="right-chat-active"
      >
        <div
          style={isMobile ? {} : { marginLeft: "10%", marginTop: "16px" }}
          className="mb-16px"
        >
          <span
            className="clip-pre-url hover"
            onClick={() => history.push("/stories")}
          >
            {t("stories.stories")}{" "}
          </span>
          <span className="text-12px f-black darktheme-txt">
            {" / "}
            {t("stories.uploadStories")}
          </span>
        </div>
        
        <div
          className={`${isMobile || isTab ? " mb-5" : ""} ${
            isTab === true ? "middle-sidebar-bottom" : "desk-modal-up"
          }`}
          style={
            isMobile
              ? { height: "100%", display: "grid", alignContent: "center" }
              : {}
          }
        >
          <div
            onDrop={handleFileDrop}
            onDragOver={handleDragOver}
            className="card w-100 clip-container"
          >
            <input
              onChange={handleFileChange}
              type="file"
              ref={clickInput}
              style={{ display: "none" }}
              accept={
                ".jpg, .jpeg, .gif, .png, .mp4, .mov, .quicktime, .moov, .m4v, .mpg, .mpeg, .wmv, .avi, .webm, .mkv"
              }
            />
            <div className="card-body p-0 mt-3">
              <div className="absolute-center">
                {uploadedMediaDataUrl === "" ? (
                  <img
                    alt="Upload placeholder"
                    src={`${AWS_URL}logo/upload_placeholder.png`}
                    height={80}
                    width={80}
                  />
                ) : (
                  <>
                    {fileType === "image" && (
                      <img
                        alt="Uploaded content"
                        className="br-8px image-fit-300"
                        width={"100%"}
                        src={uploadedMediaDataUrl}
                      />
                    )}

                    {fileType === "video" && (
                      <video
                        className={`${
                          isMobile ? "w-100 h-100" : "mw-332px"
                        } br-8px`}
                        width={"100%"}
                        controls
                        controlsList="nodownload nocontextmenu noremoteplayback"
                        onContextMenu={(e) => e.preventDefault()}
                      >
                        <source
                          src={uploadedMediaDataUrl}
                          type="video/mp4"
                        />
                      </video>
                    )}
                    
                    {fileType === "undefined" && (
                      <div>This file is not valid</div>
                    )}
                  </>
                )}
              </div>
              
              {uploadedMedia === "" && (
                <div className="absolute-center upload-media-text">
                  {t("clip.uploadMedia")}
                </div>
              )}
              
              {!isMobile && uploadedMedia === "" && (
                <>
                  <div className="absolute-center wallet-info">
                    {t("clip.dragAndDrop")}
                  </div>
                  <div className="absolute-center wallet-info">
                    {t("clip.or")}
                  </div>
                </>
              )}
              
              <div
                onClick={() => clickInput.current && clickInput.current.click()}
                className="absolute-center clip-browse hover"
              >
                {t("clip.browseMedia")}
              </div>
            </div>
          </div>
          
          <div className="clip-what d-flex justify-content-center">
            <Button
              onClick={() => submitStories(inputFileStory, inputFileEvent)}
              disabled={loading}
              className="align-center fix-buttom mb-0 p-0 btn p-2 lh-24 w125 d-inline-block rounded-xl subscriptionSubscibe border-red detailTitle fw-700 ls-lg text-white"
            >
              {t("stories.uploadStories")}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default UploadStories;